/**
 * @name          Reference list and map plugin
 * @version       1.0
 * @lastmodified  2015-12-02
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JR, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'referenceList',
		defaults = {
			searchUrl: null,
			offcanvasFilterMaxWidth: 767,
			largeResultItemsMinWidth: 1024,
			hideMapMaxWidth: 767,
			rows: 10,
			scrollTopDuration: 500
		};

	var View = {
		MAP:  'map',
		LIST: 'list'
	};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);
		this.init();
	}

	// methods
	var methods = {
		init: function() {

			var self = this;

			self.view = View.LIST;
			self.$filter = self.$element.find('.filter');
			self.$filterContainer = self.$element.find('.referenceList__filter');
			self.$resultContainer = self.$element.find('.referenceList__results');
			self.$listContainer = self.$resultContainer.find('.referenceList__resultItems');
			self.$map = self.$resultContainer.find('.referenceList__resultMap');
			self.mapInitialized = false;
			self.urlParameters = $.deparam(window.location.search.replace(/^\?/,''));

			self.initFilteredSearch();
			self.initListeners();

		},

		initFilteredSearch: function() {

			var self = this;

			// init generic filtered search
			self.$filter.filteredSearch({
				searchUrl: self.options.searchUrl,
				breakpoint: self.options.offcanvasFilterMaxWidth,
				filterContainerSelector: '.referenceList__filter',
				rows: self.options.rows
			});

		},

		initListeners: function(){

			var self = this;

			if (self.$element.find('.referenceList__toggleMap').length > 0) {
				// init show map
				self.$element.find('.referenceList__toggleMap').on('click', function(e) {
					e.preventDefault();

					// toggle button text
					var $button = $(this);
					var newText = $button.data( 'toggle-text' );
					$button.data('toggle-text', $button.text());
					$button.text( newText );

					// toggle map container
					self.$resultContainer.toggleClass('referenceList__results--map');

					// set rendering view type
					if( self.view === View.LIST ) {
						self.view = View.MAP;
						self.$filter.trigger('do.search.filteredSearch', [ false, 0, global.configuration.get('global.referenceMapRows'), true ]);
					} else {
						self.view = View.LIST;
						self.$filter.trigger('do.search.filteredSearch', [ false, 0, global.configuration.get('global.referenceSearchRows'), true ]);
					}

					// maximizeMapWidth();
					self.maximizeMapWidth();

					// redraw map
					if( self.mapInstance && self.mapInstance.map && self.view === View.MAP ) {
						google.maps.event.trigger(self.mapInstance.map, 'resize');
					}
				});

				// hide map if viewport gets too small
				enquire.register('screen and (max-width: '+ self.options.hideMapMaxWidth +'px)', {
					match: function() {
						if( self.view === View.MAP ) {
							self.$element.find('.referenceList__toggleMap').trigger('click');
						}
					}
				});
			}

			// listen to search for new data
			self.$filter.on('new.data.filteredSearch', function( event, data, addData ) {
				if( self.view === View.LIST ) {
					self.renderList( data, addData );
				} else {
					self.renderMap( data, addData );
				}
			});

			// listen for rendered data
			this.$element.one('loaded.data.referenceList', function () {
				if (Modernizr.history && self.urlParameters.activeItem) {
					self.goToItem(self.urlParameters.activeItem);
				}
			});

			// listen to more button
			self.$resultContainer.find('.referenceList__moreButton > a').on('click', function(e) {
				e.preventDefault();
				self.$filter.trigger('do.search.filteredSearch', [ true ]);
			});

			if (Modernizr.history) {
				// listen for click on result item
				self.$element.on('click', '.teaser__linkedWrapper', function (e) {
					e.preventDefault();

					var $activeItem = $(this);
					var href = $activeItem.attr('href');
					var urlParamObject = $.deparam(window.location.search.replace(/^\?/, '')) || {};

					// add active item and row count as url parameter
					urlParamObject.activeItem = $activeItem.closest('.teaser').index();
					urlParamObject.rows = $activeItem.closest('.referenceList__resultItems').children().length;
					history.replaceState('', '', '?' + $.param(urlParamObject));
					localStorage.setItem('backLinkUrl', window.location);

					// follow link url
					window.location = href;
				});
			}

			// listen to resize event
			$(window).on('debouncedwidth', function() {
				self.maximizeMapWidth();
			});

			if (!this.$element.hasClass('referenceList--gallery')) {
				// listen to data loaded event and resize on desktop screens for container height equalizing
				enquire.register('screen and (min-width: '+ self.options.largeResultItemsMinWidth +'px)', {
					match: function() {
						self.equalizeResultItems();

						self.$element.on('loaded.data.referenceList', function() {
							self.equalizeResultItems();
						});

						$(window).on('debouncedwidth.referenceList', function() {
							self.equalizeResultItems();
						});
					},

					unmatch: function() {
						// disable all events
						self.$element.off('loaded.data.referenceList');
						$(window).off('debouncedwidth.referenceList');

						// reset equalized height
						self.$listContainer.find('.teaser__content').height('auto');
					}
				});
			}

		},

		renderList: function( data, addData ) {

			var self = this;

			// render complete result list
			var html = biotope.configuration.data.tpl.referenceListResults(data);

			// clean container if it's a new search
			if( addData ) {
				self.$listContainer.append( html );
			} else {
				self.$listContainer.html( html );
			}

			// toggle more button
			self.$resultContainer.toggleClass(
				'referenceList__results--more',
				parseInt(data.response.numFound, 10) > parseInt(data.responseHeader.params.start, 10) + parseInt(data.responseHeader.params.rows, 10)
			);

			var $images = self.$listContainer.find('.picture');
			var initialImageCount = $images.length;
			var loadedImageCount = 0;

			// listen on responsive image load event
			$images.on('load.source.responsiveImage', function () {
				loadedImageCount++;

				// trigger loaded event when all responsive images are loaded
				if (loadedImageCount === initialImageCount) {
					self.$element.trigger('loaded.data.referenceList');
				}
			});

			// load images responsive
			self.$element.find('.picture').responsiveImage({
				autoDpr: true
			});
		},

		renderMap: function( data ) {

			var self = this;

			// init map only once
			if( !self.mapInitialized ) {

				// init map plugin
				self.$map.stoMap({
					data: self.prepareMarkerJson( data ),
					markerImage: global.configuration.get('staticResourcesBase') + global.configuration.get('global.markerImage'),
					callback: function() {
						self.mapInstance = this;
					}
				});

				self.mapInitialized = true;

			} else {

				var markers = self.prepareMarkerJson( data );
				self.$map.data('plugin_stoMap')
					.removeMarkers()
					.addMarkers( markers );

			}

		},

		prepareMarkerJson: function( data ) {

			/*jshint camelcase: false */
			var markers = [];
			for (var i=0; i<data.response.docs.length; ++i) {

				// TODO reset image source

				var reference = data.response.docs[i];
				markers.push({
					'headline': reference.headline,
					'subline':  reference.subline,
					'image':    reference.thumbnail_240,
					'lat':      reference.coordy,
					'lng':      reference.coordx
				});
			}
			/*jshint camelcase: true */

			return markers;
		},

		equalizeResultItems: function() {

			var self = this;

			// resize large teasers to fit the two smaller boxes
			var $teasers = self.$listContainer.find('.teaser');
			$teasers.each(function(i) {
				if( i % 3 === 0 ) {
					if( $teasers.length < i+3 ) {
						return false;
					}

					// grab element heights including one margin-top
					var totalHeight = $teasers.eq(i+1).height();
					totalHeight += $teasers.eq(i+2).height();
					totalHeight += parseInt($teasers.eq(i+1).css('margin-top'), 10);

					var $teaserContent = $(this).find('.teaser__content');
					$teaserContent.height( totalHeight - $(this).height() + $teaserContent.height() );
				}
			});
		},

		maximizeMapWidth: function() {
			var self = this;

			if( self.view !== View.MAP ) {
				return;
			}

			var marginLeft = self.$map.offset().left - parseInt(self.$map.css('margin-left'), 10);
			self.$map.css('margin-left', -marginLeft);
		},

		goToItem: function (index) {
			var $activeItem = $(this.$listContainer.find('.teaser').get(index));

			if ($activeItem.length) {
				var activeItemOffset = $activeItem.first().offset().top - $.getHeaderHeight();

				// scroll to active item on page load
				$('html, body').animate({
					scrollTop: activeItemOffset
				}, {
					duration: this.options.scrollTopDuration,
					complete: function () {
						var urlParamObject = $.deparam(window.location.search.replace(/^\?/, '')) || {};
						delete urlParamObject.activeItem;
						delete urlParamObject.rows;
						history.replaceState('', '', '?' + $.param(urlParamObject));
					}
				});
			}
		}
	};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function(options) {
		this.each(function() {
			if(!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				/**
				 * DEV-note: Use trigger failsafe events if other plugins depend on this plugins ready state
				 */
				// trigger ready event on element - optional
				//$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally - optional
		//if(this.length > 0) {
		//    $.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		//}

		return this;
	};

})(jQuery, window, document);
